const RECOVERABLE_CONFLICT_CODES = new Set([
  'DISPATCH_PLAN_INVALID',
  'DISPATCH_PLAN_EXPIRED',
  'DISPATCH_PLAN_STALE',
  'DISPATCH_TARGET_MISMATCH',
  'DISPATCH_CONFIRM_CONFLICT',
  'TASK_CONFIG_REVISION_STALE',
])

export function isRecoverableDispatchConflict(error) {
  if (Number(error?.status) !== 409) return false
  const code = String(error?.code || '').toUpperCase()
  return RECOVERABLE_CONFLICT_CODES.has(code)
    || code.startsWith('APP_CONFIG_')
    || code.startsWith('MATERIAL_')
    || code.startsWith('V4_')
}

export async function withDispatchConflictRecovery(operation, onRetry, maxAttempts = 2) {
  let attempt = 0
  while (attempt < maxAttempts) {
    try {
      return await operation(attempt)
    } catch (error) {
      attempt += 1
      if (attempt >= maxAttempts || !isRecoverableDispatchConflict(error)) throw error
      await onRetry(error, attempt)
    }
  }
  throw new Error('dispatch retry attempts exhausted')
}
